import axios from 'axios';

// slices
import { setMainLoading } from '../app/adminSlice';
import { login } from '../app/authSlice';
import { createAsyncThunk } from '@reduxjs/toolkit';


// link API
const loginLink = window.appConfig.restapiUrl + "/account/authenticate_user/";
const guestLink = window.appConfig.restapiUrl + "/account/guest_token/";


export const postLogin = createAsyncThunk(
    "auth/login/loginAsync",
    async ({ username, password }, thunkAPI) => {
    try {
        thunkAPI.dispatch(setMainLoading(true));

        const response = await axios.post(loginLink, { username: username, password: password })
        
        // const authMessage = response.data.authenticationmessage;
        const authId = response.data.authenticationstatusid;

        if (authId === 0) {
            sessionStorage.setItem("user", JSON.stringify(response.data.user_data));
            sessionStorage.setItem("token", response.data.access_token);

            //without bearer v
            axios.defaults.headers.common["Authorization"] = "Bearer" + response.data.access_token;
            axios.defaults.headers.common["X-Frontend-Path"] = window.location.pathname;
            thunkAPI.dispatch(login(response.data.user_data));

        } 
        // else {
        //     alert(authMessage);
        // }
        thunkAPI.dispatch(setMainLoading(false));
        return response.data;

    } catch (error) {
        // console.error("Error login:", error.message, error);
        thunkAPI.dispatch(setMainLoading(false));

        if (error.response) {

            console.error("Server error response:", error.response.data);
        } else if (error.request) {

            console.error("No response received:", error.request);
        } else {

            console.error("Error setting up request:", error.message);
        }
    }
});

export const getGuestLogin = async(dispatch) =>{
    try {
        const response = await axios.get(guestLink);

        if(response){
            sessionStorage.setItem("token", response.data.access_token);
        }
    } catch (error) {
        console.error("Couldn't fetch guest's authentication", error);
    }
}